enum TableHeaderTypes {
    Order = 'orderColumnFilters',
    Settlement = 'settlementColumnFilters',
    Log = 'logColumnFilters',
}

export default TableHeaderTypes;
